import styled from 'styled-components';

export const UniversalLoginStyled = styled.div``;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/UniversalLogin/styled.js